import DOMPurify from 'dompurify'
import { mapGetters } from 'vuex'

export default {
  name: 'TrackerDataTableTitle',

  props: {
    propTitle: String,
    propDescription: String,
    propViewTitle: String,
    mode: String,
    itemDTO: Object
  },

  computed: {
    ...mapGetters({
      DomPurifyAttrs: 'configurationStore/DOMPurify'
    }),
    computedTitle () {
      let title = this.capitalize(this.propTitle)
      if (this.mode && this.mode !== 'insert' && this.itemDTO) {
        title = title + ' ' + this.itemDTO.id
      }
      return title
    },
    computedDescription () {
      return DOMPurify.sanitize(this.propDescription, {
        ALLOWED_TAGS: this.DomPurifyAttrs.ALLOWED_TAGS || ['b', 'em', 'strong', 'br'],
        ALLOWED_ATTR: this.DomPurifyAttrs.ALLOWED_ATTR || []
      })
    }
  },

  methods: {

    capitalize (str) {
      return str && `${str[0].toUpperCase()}${str.slice(1)}`
    }
  }
}
